export default "__VITE_ASSET__BQXOyGBc__"